// QuickActions - Sprint 44 Fase 3 Vista 1.
// Accesos rapidos del dashboard. Modernizado vs legacy:
//   - Usa tokens XL (sin Tailwind hardcoded).
//   - Dark mode automatico.
//   - [FIX bug heredado] Ruta '/importacion-usa' -> '/importaciones'
//     (la ruta legacy fue eliminada en S31.1 y dejaba un 404 silencioso).
//   - [FIX bug heredado] Label 'Importacion USA' -> 'Importaciones' para
//     coincidir con sidebar XL y la ruta multi-modalidad real.
//
// Definicion declarativa para no duplicar la lista en multiples lugares.
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ensureKeyframes, injectCSS } from '../../../design/motion';

const CSS_ID = 'xl-quick-actions-css';
const CSS = `
.xl-qa {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 4px;
}
.xl-qa__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 14px;
  border-radius: var(--xl-radius-md);
  border: 1px solid var(--xl-color-border);
  background: var(--xl-color-bg);
  color: var(--xl-color-text);
  font-family: var(--xl-font-sans);
  font-size: 13px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: background 120ms cubic-bezier(0,0,0.2,1),
              border-color 120ms cubic-bezier(0,0,0.2,1),
              color 120ms cubic-bezier(0,0,0.2,1);
}
.xl-qa__item:hover {
  background: var(--xl-color-surface-alt);
  border-color: rgba(46, 55, 69, 0.25);
}
.xl-qa__item:focus-visible {
  outline: 2px solid var(--xl-color-focus);
  outline-offset: 2px;
}
.xl-qa__accent {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px; height: 28px;
  border-radius: var(--xl-radius-md);
  margin-right: 10px;
  background: var(--xl-color-surface-alt);
  color: var(--xl-color-text-secondary);
  font-size: 14px;
  flex-shrink: 0;
}
.xl-qa__item--info    .xl-qa__accent { background: rgba(37,99,235,0.12);  color: var(--xl-color-info) }
.xl-qa__item--success .xl-qa__accent { background: rgba(5,150,105,0.12);  color: var(--xl-color-success) }
.xl-qa__item--warning .xl-qa__accent { background: rgba(217,119,6,0.12);  color: var(--xl-color-warning) }
.xl-qa__item--indigo  .xl-qa__accent { background: rgba(99,102,241,0.12); color: #6366F1 }

[data-xl-theme="dark"] .xl-qa__item--info    .xl-qa__accent { background: rgba(96,165,250,0.18) }
[data-xl-theme="dark"] .xl-qa__item--success .xl-qa__accent { background: rgba(16,185,129,0.18) }
[data-xl-theme="dark"] .xl-qa__item--warning .xl-qa__accent { background: rgba(245,158,11,0.18) }
[data-xl-theme="dark"] .xl-qa__item--indigo  .xl-qa__accent { background: rgba(165,180,252,0.18); color: #A5B4FC }

.xl-qa__label {
  display: flex;
  align-items: center;
  min-width: 0;
}
.xl-qa__chev {
  color: var(--xl-color-text-muted);
  font-size: 16px;
  line-height: 1;
  margin-left: 8px;
  flex-shrink: 0;
}
`;

// Ruta '/importaciones' verificada en src/routes/AppRoutes.jsx
// La antigua '/importacion-usa' fue removida en S31.1 (handoff explicito).
const ACTIONS = [
  { to: '/importaciones', label: 'Importaciones',     accent: 'info',    icon: '\u2693' },
  { to: '/po',            label: 'Purchase Orders',   accent: 'neutral', icon: '\u2630' },
  { to: '/inventario',    label: 'Inventario',        accent: 'success', icon: '\u25A3' },
  { to: '/grn',           label: 'GRN (Recepciones)', accent: 'warning', icon: '\u2261' },
  { to: '/productos',     label: 'Productos',         accent: 'indigo',  icon: '\u29C5' },
];

export default function QuickActions() {
  useEffect(() => {
    ensureKeyframes();
    injectCSS(CSS_ID, CSS);
  }, []);

  const navigate = useNavigate();

  return (
    <div className="xl-qa" role="list">
      {ACTIONS.map((a) => {
        const cls = 'xl-qa__item' + (a.accent !== 'neutral' ? ' xl-qa__item--' + a.accent : '');
        return (
          <button
            key={a.to}
            type="button"
            role="listitem"
            className={cls}
            onClick={() => navigate(a.to)}
          >
            <span className="xl-qa__label">
              <span className="xl-qa__accent" aria-hidden="true">{a.icon}</span>
              <span>{a.label}</span>
            </span>
            <span className="xl-qa__chev" aria-hidden="true">{'\u203A'}</span>
          </button>
        );
      })}
    </div>
  );
}
